//staging
// const API_COMMON_URL = "https://staging.api.ihrmeet.com/api/v1/common";
// const API_V1_USERS = "https://staging.api.ihrmeet.com/api/v1/users";
// const API_V1 = "https://staging.api.ihrmeet.com/api/v1";
// const AUTH_API = "https://staging.api.ihrmeet.com/oauth/token";
// const COPY_LINK = "https://stg.ihrmeet.com/#/room";

// live
const API_COMMON_URL = "https://apiv2.ihrmeet.com/api/v1/common";
const API_V1_USERS = "https://apiv2.ihrmeet.com/api/v1/users";
const API_V1 = "https://apiv2.ihrmeet.com/api/v1";
const AUTH_API = "https://apiv2.ihrmeet.com/oauth/token";
const COPY_LINK = "https://live.ihrmeet.com/#/room";

export { API_COMMON_URL, API_V1_USERS, API_V1, AUTH_API, COPY_LINK };
